<template>
    <kgr-lightbox
        :value="show"
        :headline="tHeadline"
        animated
        @post-input="closeModal"
    >
        <div
            class="kgr-list-action-dialog"
        >
            <div
                class="kgr-alert kgr-alert--info kgr-row"
            >
                {{ tHintText }}
            </div>
            <kgr-dog-member-relation-select
                :dog-id="dogId"
                @post-input="setBookingMember"
            />
        </div>

        <div
            v-if="showSelectableExams"
            class="kgr-row"
        >
            <hr class="kgr-separator" />
            <label
                v-for="exam in offering.clubExams"
                :key="exam.id"
                class="kgr-checkbox"
            >
                <input
                    v-model="selectedExams"
                    type="checkbox"
                    class="kgr-checkbox__control"
                    :value="exam"
                    style="margin-bottom: 10px;"
                />
                <span class="kgr-checkbox__label">{{ exam.title }}</span>
            </label>
        </div>

        <hr class="kgr-separator" />

        <kgr-bookable-offering-items
            v-if="offering.salesListOfferingItems.length > 0"
            :offering-items="offering.salesListOfferingItems"
            @update:selectedSalesListOfferingItems="$emit('update:selectedSalesListOfferingItems', $event)"
        />

        <div class="kgr-row">
            <button
                class="kgr-button kgr-button--secondary"
                @click="$emit('onClose')"
            >
                {{ tButtonCancel }}
            </button>
            <button
                :disabled="addButtonDisabled"
                class="kgr-button kgr-button--accent"
                @click="selectDogAndMember"
            >
                {{ tButtonExecute }}
            </button>
        </div>
    </kgr-lightbox>
</template>

<script>
import BookableOfferingItems from './BookableOfferingItems.vue';
import DogMemberRelationSelect from '../common/form/select/ClubDogMemberRelationSelect.vue';
import Lightbox from '../common/modal/Lightbox.vue';
import Offering from '../../js/dto/offering/Offering.js'

export default {
    components: {
        'kgr-bookable-offering-items': BookableOfferingItems,
        'kgr-dog-member-relation-select': DogMemberRelationSelect,
        'kgr-lightbox': Lightbox,
    },
    props: {
        offering: {
            required: true,
            type: Offering,
        },
        dogId: {
            type: String,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            bookingMember: null,
            selectedExams: [],
        };
    },
    computed: {
        tHeadline() {
            return this.$t('Hund hinzufügen');
        },
        tHintText() {
            return this.$t('Bitte wählen Sie ein zugehöriges Mitglied aus, für welches die Buchung ausgführt werden soll');
        },
        tButtonCancel() {
            return this.$t('cancel');
        },
        tButtonExecute() {
            return this.$t('add');
        },
        showSelectableExams() {
            return this.offering.selectableExams && this.offering.clubExams.length > 1;
        },
        selectableExams() {
            return this.offering.clubExams;
        },
        addButtonDisabled() {
            return this.loading || (this.bookingMember === null || this.offering.isExam() && this.selectedExams.length === 0);
        },
    },
    created () {
        this.selectedExams = this.offering.clubExams;
    },
    methods: {
        closeModal() {
            this.$emit('onClose');
        },
        setBookingMember(member) {
            this.bookingMember = member;
        },
        selectDogAndMember() {
            this.$emit('selectDogAndMember', {
                memberId: this.bookingMember.id,
                dogId: this.dogId,
                selectedExams: this.selectedExams.map(exam => exam.id)
            });
        },
    },
}
</script>
